<!-- Main content -->
<div class="main-content fondo">

    <!-- Page content -->
    <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-5 col-md-7">
            <div class="card border-0 mb-0 p-3">
              <div class="card-header border-0">
                <div class="text-muted text-center mt-2 mb-5">
                    <img src="assets/img/logo.png">
                </div>
                <div class="btn-wrapper text-center">
                    <button mat-raised-button id="btnGoogle">
                        <img src="assets/img/btn_google.png">
                    </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

</div>

<app-loading *ngIf="loading"></app-loading>